"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var science_1 = require("../../utils/shopify-graphql/science");
var ScienceHeader_1 = require("./ScienceHeader");
var ScienceTabs_1 = require("./ScienceTabs");
var ScienceContent_1 = require("./ScienceContent");
var path_1 = require("../../utils/shopify/path");
var CtaButton_1 = require("../common/Btn/CtaButton");
var Science = function () {
    var _a = (0, hooks_1.useState)(null), scienceData = _a[0], setScienceData = _a[1];
    var _b = (0, hooks_1.useState)(0), tabIndex = _b[0], setTabIndex = _b[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, science_1.getScienceData)(handle, pathType)
            .then(function (data) {
            setScienceData(data);
        })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!scienceData && location.pathname == '/') {
        setScienceData({
            header: "Support Your Body's [br]{{mobile}}Complex Systems",
            tabs: [
                {
                    title: 'Vaginal Health',
                    imageUrlMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-vaginal-health-mobile_1.png?v=1727384725',
                    imageUrlDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-vaginal-health-desktop.png?v=1727136523',
                    details: [
                        {
                            title: 'Vaginal Health',
                            description: 'Vaginal and urinary microbiomes are the center of your urogenital system. When one is unbalanced, it can impact your overall health. Our formulas are designed to [bold]((target specific concerns like vaginal balance, odor control, and bladder function)), and can be taken together for well-rounded health & comfort.',
                        },
                    ],
                },
                {
                    title: 'Hormone Health',
                    imageUrlMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-hormone-health-mobile_1.png?v=1727384725',
                    imageUrlDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-hormone-health-desktop.png?v=1727136523',
                    details: [
                        {
                            title: 'Hormone Health',
                            description: "Many physiological symptoms in women have a common cause: changes in your hormone health. We've formulated products with clinically-studied ingredients that are shown to [bold]((help rebalance hormones to support PMS symptom relief, healthy ovarian function)), & more.",
                        },
                    ],
                },
                {
                    title: 'Menopause',
                    imageUrlMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-menopause-mobile_1.png?v=1727384725',
                    imageUrlDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-menopause-desktop.png?v=1727136523',
                    details: [
                        {
                            title: 'Menopause',
                            description: 'Menopause can cause various physical and emotional changes. Our products are designed to help you navigate this stage with comfort and confidence, [bold]((addressing symptoms like hot flashes, sleep disturbances, mood, and vaginal moisture)).',
                        },
                    ],
                },
                {
                    title: 'Pregnancy',
                    imageUrlMobile: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-pregnancy-mobile_1.png?v=1727384725',
                    imageUrlDesktop: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-science-pregnancy-desktop.png?v=1727136522',
                    details: [
                        {
                            title: 'Pregnancy',
                            description: 'Supporting male and female reproductive health is crucial for healthy  pregnancy. These formulas call on research-backed ingredients that [bold]((target egg quality, hormone levels, and sperm health to optimize reproductive function)), which creates a healthy foundation when trying to conceive.',
                        },
                    ],
                },
            ],
            color: 'gogo-orange',
            ctaColor: {
                text: 'white',
                hover: 'gogo-orange',
                backgroundStart: 'gogo-orange',
                backgroundEnd: 'gogo-pale-orange',
            },
        });
    }
    var handleClickTab = function (index) { return setTabIndex(index); };
    if (scienceData) {
        return ((0, preact_1.h)(preact_1.Fragment, null,
            (0, preact_1.h)(ScienceHeader_1.default, { header: scienceData.header }),
            scienceData.tabs.length > 1 && ((0, preact_1.h)(ScienceTabs_1.default, { data: scienceData, handleClickTab: handleClickTab, tabIndex: tabIndex, color: scienceData.color })),
            (0, preact_1.h)(ScienceContent_1.default, { color: scienceData.color, scienceData: scienceData, setTabIndex: setTabIndex, tabIndex: tabIndex }),
            (0, preact_1.h)("a", { class: "science-cta", href: location.pathname == '/' ? '/collections/shop-all' : '#anchor--product-title' },
                (0, preact_1.h)(CtaButton_1.default, { text: location.pathname == '/' ? 'SHOP ALL' : 'SHOP NOW', textColor: scienceData.ctaColor.text, backgroundColor: {
                        to: 'Left',
                        startColor: scienceData.ctaColor.backgroundStart || 'white',
                        endColor: scienceData.ctaColor.backgroundEnd || 'white',
                    }, hoverColor: scienceData.ctaColor.hover || 'white', scrollTo: location.pathname == '/' ? '/collections/shop-all' : '#anchor--product-title' }))));
    }
    else {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
};
exports.default = Science;
